import axios from 'axios';
import serverMessage from '../server-message';

export default function getListing({ length, page, search, status }) {
  return new Promise((resolve, reject) => axios
    .get('/account/system-admin/api/v1/bundles', {
      params: {
        length,
        page,
        search,
        status,
      },
    })
    .then((response) => resolve(response.data))
    .catch((error) => reject(serverMessage(error))));
}
